import { styled } from 'twin.macro';

export const Wrapper = styled.div``;
export const Notes = styled.div``;
export const Details = styled.div``;
export const IconWrapper = styled.div`
    height: 10px;
    width: 10px;
`;
